import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models/ServiceResponse'

export interface IMatchOpponent {
  id: number;
  name: string;
}

export class MatchOpponentApiService extends ApiService {
  static async getAll(q?: string): Promise<IServiceResponse<IMatchOpponent[]>> {
    return this.axios.get('match-opponents', { params: { q } })
      .then((response: AxiosResponse<IServiceResponse<IMatchOpponent[]>>) => response.data)
  }

  static async create(name: string): Promise<IServiceResponse<IMatchOpponent>> {
    return this.axios.post('match-opponents', { name })
      .then((response: AxiosResponse<IServiceResponse<IMatchOpponent>>) => response.data)
  }

  static async update(matchOpponent: IMatchOpponent): Promise<IServiceResponse<IMatchOpponent>> {
    return this.axios.put(`match-opponents/${matchOpponent.id}`, { name: matchOpponent.name })
      .then((response: AxiosResponse<IServiceResponse<IMatchOpponent>>) => response.data)
  }

  static async delete(matchOpponentId: number): Promise<AxiosResponse> {
    return this.axios.delete(`match-opponents/${matchOpponentId}`)
  }
}
